import { useEffect, useMemo, useState } from 'react';
import { SidebarItem } from '../types';
import { MenuNode, layoutFile, menuDefaults, parseLayout, reconcileLayout, renderLayout } from './layout';

export default function useMenuLayout(items: SidebarItem[], storageKey: string) {
  const defaults = useMemo(() => menuDefaults(items), [items]);
  const [saved, setSaved] = useState<{ key: string; items: MenuNode[] | null }>({ key: '', items: null });
  useEffect(() => {
    const read = () => {
      try {
        const raw = localStorage.getItem(storageKey);
        setSaved({ key: storageKey, items: raw ? parseLayout(JSON.parse(raw)).items : null });
      } catch {
        setSaved({ key: storageKey, items: null });
      }
    };
    read();
    const onStorage = (event: StorageEvent) => { if (event.key === storageKey || event.key === null) read(); };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [storageKey]);
  const nodes = useMemo(() => reconcileLayout(
    saved.key === storageKey && saved.items ? saved.items : [], defaults.items, defaults.catalog
  ), [saved, storageKey, defaults]);
  const save = (next: MenuNode[], reset: boolean) => {
    if (reset) localStorage.removeItem(storageKey);
    else localStorage.setItem(storageKey, JSON.stringify(layoutFile(next)));
    setSaved({ key: storageKey, items: reset ? null : next });
  };
  return { nodes, defaults, save, items: renderLayout(nodes, defaults.catalog) };
}
